/* eslint-disable */
/**
 * @file 通用js类
 * Created by liuyanan06 on 2018/8/21.
 */
import util from './tools';
import {getAndroidVersion} from './util';
import jsonp from './jsonp.js'
// 全局common类
const common = {};
/**
 *  将url中的参数  a=1&b=2 转成对象 { a: 1, b: 2 }
 * @param {String} str
 * @returns {Object}
 */
common.parseUrlStringToObject = function (str) {
    let obj = {};
    if (!str) {
        return {};
    }
    let arr = str.split('&');
    for (let index = 0; index < arr.length; index++) {
        let tmp = arr[index].split('=');
        if (tmp[1]) {
            // 判断a=&b=2的情况 去掉a
            obj[tmp[0]] = tmp[1];
        }
    }
    return obj;
};
/**
 * 将 { a:1, b:2 } 转成 a=1&b=2
 * @param {Object} obj
 * @returns  {String}
 */
common.parseObjectToUrlString = function (obj) {
    let arr = [];
    let tmp = '';
    for (let k in obj) {
        if (obj.hasOwnProperty(k)) {
            tmp = k + '=' + obj[k];
            arr.push(tmp);
        }
    }
    return arr.join('&');
};
/**
 * 获取url中参数
 * @returns {a:1,b:2}
 */
common.getParamsFromUrl = function () {
    let self = this;
    if (window.location.hash.indexOf('?') !== -1) {
        return self.parseUrlStringToObject(window.location.hash.split('?').pop());
    }
    if (window.location.href.indexOf('?') !== -1) {
        return self.parseUrlStringToObject(window.location.href.split('?').pop().split('#')[0]);
    }
    return {};
};
/**
 * 字符串str是否以固定字符串startStr开始
 * @param str
 * @param startStr
 * @returns {boolean}
 */
common.startWith = function (str, startStr) {
    if (!str || !startStr || str.length == 0 || startStr.length > str.length) return false;
    if (str.substr(0, startStr.length) == startStr) return true;
    else {
        return false;
    }
};
// 判断js数据类型
common.type = function (obj) {
    return Object.prototype.toString.call(obj).slice(8, -1);
};
// 是否是iphonex系列
common.isIphoneX = function () {
    // X XS, XS Max, XR
    const xSeriesConfig = [{
            devicePixelRatio: 3,
            width: 375,
            height: 812
        },
        {
            devicePixelRatio: 3,
            width: 414,
            height: 896
        },
        {
            devicePixelRatio: 2,
            width: 414,
            height: 896
        }
    ];
    if (typeof window !== 'undefined' && window) {
        const isIOS = /iphone/gi.test(window.navigator.userAgent);
        if (!isIOS) return false;
        const {
            devicePixelRatio,
            screen
        } = window;
        const {
            width,
            height
        } = screen;
        return xSeriesConfig.some(
            item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height
        );
    }
    return false;
}
// 判断平台信息
common.plat = (function () {
    let res = {},
        ua = navigator.userAgent,
        mobileReg = /android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (Fire)|Silk|maemo|blackberry|playbook; (touch|kbd)|Symbian(OS)|Ubuntu Touch/i,
        iosReg = /ip(hone|ad|od)/i;
    if (!ua) {
        ua = '';
    }
    ua = ua.toLowerCase();
    res.isAndroid = ua.indexOf('android') > -1;
    res.isIos = iosReg.test(ua);
    res.isWeixin = ua.indexOf('micromessenger') > -1;
    res.isWeibo = ua.indexOf('weibo') > -1;
    res.isWeChatOrWeiBo = res.isWeixin && res.isWeibo;
    res.isBaiduMap = ua.indexOf('baidumap_') > -1;
    res.isMobile = mobileReg.test(ua);
    res.isPc = !res.isMobile;
    if (res.isAndroid) {
        res.androidVersion = getAndroidVersion();
    }
    // 只有7.0.0版本以上，给userAgent做了特殊处理，才返回true。经过导航组件的web页面，有时候会莫名的丢失ua，不确定ua是什么形式。
    var isNative =
        ua.indexOf('baidumap_andr') > -1 || (ua.indexOf('baidumap_ipho') > -1 || ua.indexOf('baidumap_ipad') > -1);
    res.isNative = !res.isWeibo && !res.isWeixin && (isNative || res.isNull);
    // 判断android or Ios
    res.os = res.isIos ? 'IOS' : res.isAndroid ? 'android' : 'others';
    res.isBaiduMapSchema = function (url) {
        let bool = common.startWith(url, 'baidumap') || common.startWith(url, 'bdapi');
        return bool;
    };
    if (res.isBaiduMap) {
        res.mode = 'map';
    } else if (res.isWeixin) {
        res.mode = 'weixin';
    } else if (res.isWeibo) {
        res.mode = 'weibo';
    } else {
        res.mode = 'others';
    }
    return res;
})();
/**
 * openApi接口
 * @param url
 * @param data
 */
common.openBaiduMap = function (url, data) {
    url = util.appendParam(url, data);
    if (common.plat.isAndroid) {
        util.makeIframeRequest(url, true);
    } else {
        util.makeAnchorRequest(url, true);
    }
};
/**
 * bdapi接口
 * @param url
 * @param data
 * @param success
 * @param {boolean} clear 是否一次回调后即清除回调函数 默认true
 * @return {string} 生成的回调函数名 外界调用者可根据回调函数名自行清除回调
 */
common.requestBdApi = function (url, data, success, clear) {
    if (util.objectType(data) == 'Function') {
        success = data;
        clear = success;
        data = {};
    }
    // 回调函数名
    var callbackName;
    url = util.appendParam(url, data);
    if (util.objectType(success) == 'Function') {
        url = util.appendCallback(url, success, clear);
        var result = url.match(/(&|\?)callback=([^&#]*)?(&|#|$)/);
        if (result && result[2]) {
            callbackName = result[2];
        }
    }
    util.makeIframeRequest(url, true);
    return callbackName;
};
/**
 * 使用端浏览器打开，协议'baidumap://map/cost_share',默认位置强关联, ios8.8.0新增'needLocation=yes'才能获取定位
 * Openapi调起统计参数规范: src: 产品线.功能.页面.元素  例如: webapp.cost_share.page.icon
 * @param url: string
 * @param page: string
 * @param icon: string
 * @param returnStr: Boolean 是否返回cost_share协议的字符串
 */
common.openInMap = function (url, page, icon, returnStr) {
    var urlPath = location.pathname.split('/');
    urlPath = urlPath && urlPath[urlPath.length - 2] ? urlPath[urlPath.length - 2] : 'main';
    page = page || urlPath || 'main';
    icon = icon || 'autojump';
    var data = {
        url: url,
        src: 'webapp.cost_share.' + page + '.' + icon,
        needLocation: 'yes'
    };
    // 添加baiduid
    var strMatch = (document.cookie + ';').match(/BAIDUID=([^;]*);/);
    if (strMatch && strMatch.length > 1) {
        data.bdlog = JSON.stringify({
            baiduid: strMatch[1]
        });
    }
    // if (query.sharecallbackflag) {
    //   data.sharecallbackflag = query.sharecallbackflag;
    // }
    if (returnStr) {
        return util.appendParam('baidumap://map/cost_share', data);
    } else {
        common.openBaiduMap('baidumap://map/cost_share', data);
    }
};
// 微信微博中提示浏览器打开浮层
common.openLayer = function () {
    // 页面已有浮层
    if (!document.getElementById('naa-share-fc')) {
        // 浮层dom和样式
        var div = document.createElement('div');
        div.style.cssText =
            'background-color: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; top: 0; left: 0; bottom: 0; z-index: 9999; overflow: hidden;';
        div.id = 'naa-share-fc';
        var img = document.createElement('img');
        img.style.cssText = 'margin-left:19%;width:80%;';
        img.setAttribute('src', 'https://webmap0.bdimg.com/zt/y2016/welfareday/images/share_arrow_5179ee7.png');
        div.appendChild(img);
        document.body.appendChild(div);
        // 点击浮层隐藏
        document.getElementById('naa-share-fc').addEventListener(
            'click',
            function (e) {
                this.style.display = 'none';
            },
            false
        );
        // 出浮层时不能滚动
        document.getElementById('naa-share-fc').addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault();
            },
            false
        );
    } else {
        document.getElementById('naa-share-fc').style.display = 'block';
    }
};
//  判断是否支持hidden属性，窗口是否隐藏及isHidden=true
var pageVisibility = (function () {
    var prefixSupport = null;
    var keyWithPrefix = function (prefix, key) {
        if (prefix !== '') {
            // 首字母大写
            return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
        }
        return key;
    };
    // 是否支持页面可见性判断属性
    var isPageVisibilitySupport = (function () {
        var support = false;
        if (typeof window.screenX === 'number') {
            ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
                if (support == false && document[keyWithPrefix(prefix, 'hidden')] != undefined) {
                    prefixSupport = prefix;
                    support = true;
                }
            });
        }
        return support;
    })();
    // 检测页面对于用户的可见性
    var isHidden = function () {
        if (isPageVisibilitySupport) {
            return document[keyWithPrefix(prefixSupport, 'hidden')];
        }
        return undefined;
    };
    var visibilityState = function () {
        if (isPageVisibilitySupport) {
            return document[keyWithPrefix(prefixSupport, 'visibilityState')];
        }
        return undefined;
    };
    return {
        prefix: prefixSupport,
        isSupport: isPageVisibilitySupport,
        isHidden: isHidden,
        visibilityState: visibilityState,
        visibilitychange: function (fn) {
            if (isPageVisibilitySupport && typeof fn === 'function') {
                var self = this;
                return document.addEventListener(
                    prefixSupport + 'visibilitychange',
                    function (evt) {
                        self.hidden = isHidden();
                        self.visibilityState = visibilityState();
                        fn.call(self, evt);
                    },
                    false
                );
            }
            return undefined;
        }
    };
})(undefined);
common.jumpHandler = {
    android: {
        weixinbo: function (openapi) {
            common.openLayer();
            // openapi =
            //     openapi || common.openInMap(location.origin + location.pathname + location.search, null, null, true);
            // var yybHref = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.baidu.BaiduMap&android_schema=';
            // if (common.plat.isWeixin) {
            //     // 安卓在微信里应用宝的处理方式
            //     location.href = yybHref + encodeURIComponent(openapi);
            // } else {
            //     common.openLayer();
            // }
        },
        duer: function (openapi) {
            // 度口令调起
            window.yymap.nativeAppAdapter.openClient({
                openapi: openapi,
                iosTime: 3000
            }, true);
        },
        others: function (immediately) {
            if (immediately) {
                window.location.href = 'https://map.baidu.com/zt/client/index/';
            } else {
                var clickedAt = +new Date();
                var isHidden = pageVisibility.isSupport && pageVisibility.isHidden();
                setTimeout(function () {
                    if (+new Date() - clickedAt < 1550) {
                        if (!isHidden) {
                            setTimeout(function () {
                                window.location.href = 'https://map.baidu.com/zt/client/index/';
                            }, 1000);
                        }
                    }
                }, 1500);
            }
        }
    },
    ios: {
        weixinbo: function (curl, openapi) {
            // universalLinks打开openapi
            window.yymap.nativeAppAdapter.universalLinks(curl, openapi, {});
            common.openLayer();
        },
        duer: function (openapi) {
            // 度口令调起
            window.yymap.nativeAppAdapter.openClient({
                openapi: openapi,
                iosTime: 300
            }, true);
        },
        others: function (immediately) {
            if (immediately) {
                window.location.href = 'https://map.baidu.com/zt/client/index/';
            } else {
                var clickedAt = +new Date();
                var isHidden = pageVisibility.isSupport && pageVisibility.isHidden();
                setTimeout(function () {
                    if (+new Date() - clickedAt < 1550) {
                        if (!isHidden) {
                            setTimeout(function () {
                                window.location.href = 'https://map.baidu.com/zt/client/index/';
                            }, 0);
                        }
                    }
                }, 1500);
            }
        }
    }
};
/**
 * 配置
 * @param opts:
 *     launchInNA [Boolean] 若不在地图，是否调起地图 默认true
 *     openapi   [String]   若存在，则调起该openapi，否则用cost_share调起
 *     immediately  [Boolean]  是否立马触发调起失败的回调
 *  @param isDuer: [Boolean]    是否使用度口令
 *  @param isAutoJump: [Boolean] 是否是自动调起，默认false
 */
common.openMapClient = function (opts, isAutoJump) {
    opts = opts || {};
    opts.curl = opts.curl || 'https://map.baidu.com/zt/client/index/';
    opts.isDuer = !util.isBlank(opts.isDuer);
    opts.launchInNA = util.isBlank(opts.launchInNA) || opts.launchInNA === true;
    isAutoJump = !!isAutoJump;
    // 是否需要调起地图
    if (opts.launchInNA && !common.plat.isNative) {
        // 安卓下，微信应用宝，微博浏览器打开
        if (common.plat.isAndroid) {
            if (common.plat.isWeibo || common.plat.isWeixin) {
                if (!isAutoJump) {
                    common.jumpHandler.android.weixinbo(opts.openapi);
                }
            } else if (opts.isDuer && opts.openapi) {
                common.jumpHandler.android.duer(opts.openapi);
            } else {
                // 浏览器中打开情况
                opts.openapi ?
                    common.openBaiduMap(opts.openapi) :
                    common.openInMap(location.origin + location.pathname + location.search);
                if (!isAutoJump) {
                    common.jumpHandler.android.others(opts.immediately);
                }
            }
        } else {
            // ios下 微信或微博打开浮层
            if (common.plat.isWeibo || common.plat.isWeixin) {
                if (!isAutoJump) {
                    // 默认通过universalLink打开协议, 并打开'浏览器中打开'浮层
                    common.jumpHandler.ios.weixinbo(opts.curl, opts.openapi);
                }
            } else if (opts.isDuer && opts.openapi) {
                common.jumpHandler.ios.duer(opts.openapi);
            } else {
                // 浏览器中打开
                if (!isAutoJump) {
                    opts.openapi ?
                        common.openBaiduMap(opts.openapi) :
                        common.openInMap(location.origin + location.pathname + location.search);
                    if (!isAutoJump) {
                        common.jumpHandler.ios.others(opts.immediately);
                    }
                }
            }
        }
    }
};
// 封装端内H5地址请求
common.openUrlByOpenApi = function (url, hiddenNavigation = false) {
    let newUrl = url;
    let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    let objExp = new RegExp(Expression);
    if (objExp.test(url)) {
        newUrl = 'baidumap://map/cost_share?popRoot=no&mode=NORMAL_MODE&needLocation=yes&src=webapp.cost_share.nationalActivity.autojump';
        if (hiddenNavigation) {
            newUrl += '&navigationStatus=2';
        }
        newUrl += '&url=' + encodeURIComponent(url);
    }
    if (common.plat.isNative) {
        window.location.href = newUrl;
    } else if (hiddenNavigation) {
        common.openBdMapNoBar(url);
    } else {
        common.openBdMap();
    }
};
common.openBdMap = function () {
    let curUrl = encodeURIComponent(location.href);
    const openapi =
        'baidumap://map/cost_share?url=' + curUrl + '&popRoot=no&mode=NORMAL_MODE&needLocation=yes&src=webapp.cost_share.nationalActivity.autojump';
    const options = {
        launchInNA: true, //是否调起地图, 默认调起
        openapi: openapi, // 默认用cost_share调起当前页面
        immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
    };
    common.openMapClient(options);
};
common.openBdMapNoBar = function (url) {
    let curUrl = encodeURIComponent(url);
    const openapi =
        'baidumap://map/cost_share?url=' + curUrl + '&popRoot=no&mode=NORMAL_MODE&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1&needLocation=yes&src=webapp.cost_share.nationalActivity.autojump';
    const options = {
        launchInNA: true, //是否调起地图, 默认调起
        openapi: openapi, // 默认用cost_share调起当前页面
        isDuer: true, // 度口令打开
        immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
    };
    common.openMapClient(options);
};
// 端内使用客户端登陆
common.goToLogin = function () {
    if (common.plat.isNative) {
        // 登录
        const sv = window.yymap.nativeAppAdapter.phoneinfo.sv || '0.0.0';
        if (util.compareSv(sv, '10.10.0') === -1) {
            window.yymap.nativeAppAdapter.gotoLogin();
        } else {
            let bdapi = 'bdapi://login';
            let params = {
                login_page: 'normal',
                third_login_enable: '0',
                loginsourcetype: '登录',
                callback: 'signinCallback', // 传callback不刷新页面，不传callback返回页面默认刷新页面
            };
            window.yymap.nativeAppAdapter.requestBdApi(bdapi, params);
        }
    } else {
        let loginUrl = 'https://wappass.baidu.com/passport/?';
        let data = {};
        let param = param || {};
        data.tpl = param.tpl || 'ma';
        data.authsite = param.autosite ? 1 : 0;
        data.u = location.href;
        data.adapter = 3; // 去掉h5中的title
        loginUrl = util.appendParam(loginUrl, data);
        location.href = loginUrl;
    }
};
// 获取地图客户端参数及url中参数
common.fetchNAParams = function () {
    return new Promise(resolve => {
        let obj = common.getParamsFromUrl();
        if (window.yymap && window.yymap.nativeAppAdapter && window.yymap.nativeAppAdapter.plat.isNative) {
            // 地图壳环境下获取nativeInfo
            new Promise(resolve => {
                window.yymap.nativeAppAdapter.getNativeInfo(result => {
                    resolve(result);
                });
            }).then(result => {
                obj = Object.assign({}, obj, result);
                resolve(obj);
            });
        } else {
            resolve(obj);
        }
    });
};
// 调地图登陆api协议
common.goToLoginApi = function () {
    var e = {
        login_page: 'normal',
        third_login_enable: '0',
        loginsourcetype: '登录',
        url: location.href
    };
    common.requestBdApi('bdapi://login', e);
};
// 防抖
common.debounce = function (fn, t) {
    let delay = t || 500;
    let timer;
    let firstTime = true;
    return function () {
        let args = arguments;
        if (firstTime) {
            fn.apply(this, args);
            return firstTime = false;
        }
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
        }, delay);
    };
};
// 判断是否是ios 8
common.isIOS8 = function() {
    if (/iphone os ([0-9]+)_/i.test(navigator.userAgent) && parseInt(RegExp.$1, 10) < 9) {
        return true;
    }
    return false;
};
common.getLoginStatus = function(opts, callback) {
    opts = opts || {};
    opts.picType = opts.picType || 'portrait';
    opts.original = opts.original || ''; // 若为1,获取用户手机号和email未经处理
    if (util.objectType(callback) == 'Function') {
        util.getJsonp('https://newclient.map.baidu.com/opn/opnbs/baseservice/checkuser', opts, callback);
    }
    return window.yymap.nativeAppAdapter;
};
// 判断是否登陆
// common.checkLogin = function () {
//   return new Promise((resolve) => {
//     window.yymap.nativeAppAdapter.getLoginStatus({}, (result) => {
//       resolve(result);
//     });
//   })
// };
common.checkLogin = function(successCallback, errorCallback) {
    let opts = {};
    opts.picType = opts.picType || 'portrait';
    opts.original = opts.original || ''; // 若为1,获取用户手机号和email未经处理
    jsonp('https://newclient.map.baidu.com/opn/opnbs/baseservice/checkuser', opts)
        .then(result => {
            if (typeof successCallback === 'function') {
                successCallback(result);
                console.log('successCallback', result);
            }
        })
        .catch(errorData => {
            if (typeof errorCallback === 'function') {
                errorCallback(errorData);
            }
        });
};
export default common;
/* eslint-enable */